// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","logo":"Header_logo__shVBB","name":"Header_name__59-C5","sticky":"Header_sticky__XEZI7"};